import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-696b03da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page prompts-page" }
const _hoisted_2 = { class: "container mx-auto pt-4 flex-center block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_Prompt = _resolveComponent("Prompt")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TheHeader),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_Breadcrumbs, { items: _ctx.breadcrumbs }, null, 8, ["items"]),
      (_ctx.prompt)
        ? (_openBlock(), _createBlock(_component_Prompt, {
            key: 0,
            prompt: _ctx.prompt,
            value: true,
            class: "w-full"
          }, null, 8, ["prompt"]))
        : _createCommentVNode("", true)
    ])
  ]))
}